import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import Layout from './components/Layout';
import Dashboards from './pages/Dashboards';
import DataEntry from './pages/DataEntry';
import SourceMaster from './pages/SourceMaster';
import DropdownMaster from './pages/DropdownMaster';
import AssetMaster from './pages/AssetMaster';
import ActivityLog from './pages/ActivityLog';
import AdminConsole from './pages/AdminConsole';
import Login from './pages/Login';

const Loading = () => (
  <div className="min-h-screen bg-[#F6F6F4] flex items-center justify-center">
    <div className="text-center">
      <div className="font-heading font-semibold text-[14px] mb-1">Loading…</div>
      <div className="text-[11px] font-mono text-[#787872]">Fetching workspace</div>
    </div>
  </div>
);

const Protected = ({ children }) => {
  const { authReady, authenticated, loading } = useApp();
  if (!authReady || loading) return <Loading />;
  if (!authenticated) return <Navigate to="/login" replace />;
  return children;
};

function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route index element={<Dashboards />} />
        <Route path="/entry" element={<DataEntry />} />
        <Route path="/entry/:snapshotId/:sourceId" element={<DataEntry />} />
        <Route path="/sources" element={<SourceMaster />} />
        <Route path="/dropdowns" element={<DropdownMaster />} />
        <Route path="/assets" element={<AssetMaster />} />
        <Route path="/activity" element={<ActivityLog />} />
        <Route path="/admin" element={<AdminConsole />} />
        <Route path="/upload" element={<Navigate to="/entry" replace />} />
        <Route path="/settings" element={<Navigate to="/entry" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
